import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { Button } from "@/components/ui/button"
import { genesysTelephonyLoggedMessageAction } from "@/lib/genesys-telephony-login"

const LoggedGenesysTelephony = () => {
  const { t } = useTranslation()

  useEffect(() => {
    if (window.opener) {
      window.opener.postMessage({ action: genesysTelephonyLoggedMessageAction }, `${window.location.origin}/patients`)
    }
  }, [])

  const handleCloseButtonClick = () => {
    window.close()
  }

  return (
    <div className="flex h-screen flex-col items-center justify-center">
      <p className="text-success mb-4 text-2xl font-bold">{t("telephony.genesys.loginSuccessfully")}</p>
      <Button variant="secondary" onClick={handleCloseButtonClick}>
        {t("common.button.close")}
      </Button>
    </div>
  )
}

export { LoggedGenesysTelephony }
